import React, { useState } from "react";
import Sidebar from "../components/Sidebar";
import BlogThumbnail from "../components/BlogThumnail"; 
import jawaan from "./content/pics/jawant.jpg"
import "./MovieReviews.css"
import khushi from "./content/pics/khushi.png"
import Sexed from "./content/pics/sexed.png"
import Sapta from "./content/pics/sapta.png"
import Jaane from "./content/pics/jaane.png"
import Khu from "./content/pics/khufiya.png"
import OMG2 from "./content/pics/omg2.png"
import FS from "./content/pics/firstsight.png"
import Hard from "./content/pics/hardfe.png"
import Rora from './content/pics/rora.png'
import Kissing from './content/pics/kissingbooth.jpg'


const MovieReviews = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState("all");

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };
  return (
    <div className="Full">
    <div className="all">
    <div className="filler"/>
      <div className="sidebar">
        <button className={`toggle-button ${isOpen ? "open" : ""}`} onClick={toggleSidebar}>
          <div className={`hamburger-icon ${isOpen ? "close" : ""}`}>
            <span className="line"></span>
            <span className="line"></span>
            <span className="line"></span>
          </div>
        </button>
        <Sidebar isOpen={isOpen} selectedItem={selectedItem} setSelectedItem={setSelectedItem} />
      </div>
      <div className="main-content">
        <div className="links-containerc">
          <a href="/">Home</a>
          <a href="/content">Content</a>
          <a href="/aboutus">About Us</a>
        </div>

        <div className="titles">
        <center><h2>Movie and Show Reviews</h2></center>
        </div>
        <div className="blog-thumbnailsm">
        <div className="blog-thumbnail-containerm">
  <a href="/jawan">
    <BlogThumbnail
      imageSrc={jawaan}
      title="Jawan"
      description="No offense,but SRK will be remembered not for DDLJ but Jawan"
    />
  </a>
</div>
<div className="second-blog-thumbnail-containerm">
<a href="/khushi">
<BlogThumbnail
      imageSrc={khushi}
      title="Khushi"
      description="No offense,but Khushi is a feel good romantic movie"
    />
  </a>
</div>
<div className="second-blog-thumbnail-containerm">
<a href="sexed/">
<BlogThumbnail
      imageSrc={Sexed}
      title="Sex Education"
      description="Rating: 4  Genre:Comedy,Coming-of-age story, Drama"
    />
  </a>
</div>
<div className="second-blog-thumbnail-containerm">
<a href="/sapta">
<BlogThumbnail
      imageSrc={Sapta}
      title="Sapta Sagaradache Ello- Side A"
      description= "Rating: 3.5  Genre:Romance,Drama"
    />
  </a>
</div>
<div className="second-blog-thumbnail-containerm">
<a href="/jaane">
<BlogThumbnail
      imageSrc={Jaane}
      title="Jaane Jaan"
      description="Rating: 3 Genre:Crime,Drama,Mystery"
    />
  </a>
</div>
<div className="second-blog-thumbnail-containerm">
<a href="/khufiya">
<BlogThumbnail
      imageSrc={Khu}
      title="Khufiya"
      description="Rating: 4.5 Genre: Spy,Thriller,Suspense"
    />
  </a>
</div>
<div className="second-blog-thumbnail-containerm">
<a href="/omg2">
<BlogThumbnail
      imageSrc={OMG2}
      title="OMG 2"
      description="Rating: 2 Genre: Comedy"
    />
  </a>
</div>
<div className="second-blog-thumbnail-containerm">
<a href="/firstsight">
<BlogThumbnail
      imageSrc={FS}
      title="Love at First Sight"
      description= "Rating: 4 Genre:Romance,Comedy"
    />
  </a>
</div>
<div className="second-blog-thumbnail-containerm">
<a href="/nohardfe">
<BlogThumbnail
      imageSrc={Hard}
      title="No Hard Feelings"
      description="Rating: 4 Genre: Comedy"
    />
  </a>
</div>
<div className="second-blog-thumbnail-containerm">
<a href="/rockyrani">
<BlogThumbnail
      imageSrc={Rora}
      title="Rocky aur Rani ki Rem Kahani"
      description="Rating: 4  Genre: Romance,Drama,Comedy"
    />
  </a>
</div>
<div className="second-blog-thumbnail-containerm">
<a href="/kissing">
<BlogThumbnail
      imageSrc={Kissing}
      title="The Kissing Booth"
      description= "Rating: It's complicated"
    />
  </a>
</div>

</div>
</div>
        
      </div>
    </div>
  
  );
};

export default MovieReviews;